const feedback = {
  submittime: "ส่งเวลา",
  processStatus: "สถานะคำแนะนำ",
  feedbackStatusYes: "ให้แสดง Feeback",
  feedbackStatusNo: "ไม่ให้แสดง Feeback",
  suggestionDetail: "คำอธิบายของคำแนะนำ",
  mobile: "หมายเลขโทรศัพท์มือถือ",
  replayStatus: "สถานะการ reply",
  feedbackRepliedYes: "Feeback reply Yes",
  feedbackRepliedNo: "Feeback reply No",
  process: "Feedback Process",
  reply: "ตอบ",
  image1: "รูปภาพ 1",
  image2: "รูปภาพ 2",
  image3: "รูปภาพ 3",
  detail: "เนื้อหาที่ reply",
  title: "คำถาม Feedback",
  questions: "คำถาม",
  search: {
    width1: "140px",
    width2: "120px",
    width3: "80px"
  },
  message1: "กรุณาใส่เนื้อหา"
} 
export default feedback